import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const get2284ReferenceData = createAsyncThunk(
  'stop/get2284ReferenceData',
  async (params) => {
    const { reference2284Url, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(reference2284Url, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const reference2284Slice = createSlice({
  name: 'stop/reference2284',
  initialState: null,
  reducers: {
    reset2284Referenc: () => null,
  },
  extraReducers: {
    [get2284ReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { reset2284Referenc } = reference2284Slice.actions;

export default reference2284Slice.reducer;
